import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import EChallanStates from "./component";

const mapStateToProps = ({
    eChallan: {
        stateList,
        isSSR
    }
}) => ({
    stateList,
    isSSR
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EChallanStates);
